import axios from "axios";
import Head from "next/head";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import { BotFilters } from "../components/BotFilters";
import BotListItem from "../components/BotListItem";
import { Footer } from "../components/Footer";
import Header from "../components/Header";
import { Pagination } from "../components/Pagination";
import { Section } from "../components/Section";
import StartWithMessengers from "../components/StartWithMessengers";
import styles from "../styles/Home.module.css";
import { useRouter } from "next/router";
import ReactGA from "react-ga4";

function BotCarousel({bots}) {
    const [current, setCurrent] = useState(0);
    const existingBots = bots.filter((bot) => {return !!bot.botId; });
    return <div className="relative w-96">
        <div className="absolute -top-10 text-black"><div className="" onClick={() => {
            setCurrent(Math.max(current - 1, 0));
        }}>-</div><div  onClick={() => {
            setCurrent(Math.min(current + 1, bots.length - 1));
        }}>+PLUS</div></div>
        {
            existingBots.map((bot, i) => {
                const where = (i < current ? -1 : (i > current ? 1 : 0));
                const left = {"-1": "0%", 0: "calc(50% - 6.5rem)", 1: "80%"}[where];
                const w = {"-1": "w-24", 0: "w-60", 1: "w-24"}[where];
                const z = {"-1": "z-10", 0: "z-20", 1: "z-10"}[where];
                const zIndex = {"-1": "10", 0: "100", 1: (existingBots.length - i)}[where];
                const top = {"-1": "top-20", 0: "top-0", 1: "top-20"}[where];
               return <div className={"absolute " + top + " " + w} style={{left, zIndex}} key={bot.botId}><BotListItem bot={bot}/></div>;
            })
        }
       </div>
}


export default function Home() {
    const router = useRouter();

    const {q, p} = router.query;
    const [bots, setBots] = useState(undefined);
    const [botCount, setBotCount] = useState(0);
    //const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const default_query = {"properties.bot_gender":"female"}; //"properties.bot_gender":"female"}; //{'properties.bot_age': {'$gte': 21}};
    const query = q ? JSON.parse(q) : default_query;
    const page = p ? parseInt(p) : 0;
    //console.log("q and query", q, query);
    const [mounted, setMounted] = useState(false);

    const seenPhotoIds = useRef(new Set());            // already counted this session
    const viewQueue = useRef(new Set());               // pending view updates
    const observerRef = useRef(null);                  // shared IntersectionObserver
    const flushTimerRef = useRef(null);                // batch flush timer

    useEffect(() => {
        async function fetchInitial() {
            const answer = await (await fetch("/api/topbots")).json();
            setBotCount(1500);
            setBots(answer.results || []);
            setLoading(false);
            setMounted(true);
        }
        fetchInitial();
    }, []);

    useEffect(() => {
        if (!mounted) return;
        //console.log("q is ");
        q && onQueryChange(JSON.parse(q))
        
    }, [mounted, q, p]);

    async function getNewBots(i, query) {
        const answer = await axios.post("https://api.holomate.io/api/botsFind", {query: {...query, botId: {$lte: 10000}, "properties.real_mate": true}, limit: pageSize, page: i});
        setBots(answer.data.result || []);
        setLoading(false);
    }

    /*useEffect(async () => {
        await getNewBots(page, query);
    }, [p]);*/

    const pageSize = 32;
    async function onQueryChange(query) {
        //setPage(0);
        setLoading(true);
        try {
            const numb = await axios.post("https://api.holomate.io/api/botsCount", {query: {...query, botId: {$lte: 10000}, "properties.real_mate": true}});
            //console.log("numb", numb)
            const cnt = numb.data.result || 0;
            setBotCount(cnt);
            if(cnt > 0) {
                await getNewBots(page, query);
            } else {
                setBots([]);
            }
                
        } catch(e) {
            console.log("onQueryChange e", e);
        }
        //console.log("answer is ", answer.data,query);        
        setLoading(false);
    } 


        /** Flush queued view increments in batches */
    async function flushViewQueue() {
        if (viewQueue.current.size === 0) return;
        const ids = [];
        for (const id of viewQueue.current) {
        ids.push(id);
        }
        await fetch("/api/ff", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ids: ids, type: "mates"}),
            cache: "no-store"
        });
        viewQueue.current.clear();
    }

    /** Start the 500ms batching timer */
    function scheduleFlush() {
        if (flushTimerRef.current) return;
        flushTimerRef.current = setTimeout(async () => {
        flushTimerRef.current = null;
        await flushViewQueue();
        }, 500);
    }

    /** Create IntersectionObserver once */
    useEffect(() => {
        observerRef.current = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const photoId = entry.target.dataset.photoId;
            if (!photoId) return;

            if (!seenPhotoIds.current.has(photoId)) {
                seenPhotoIds.current.add(photoId);
                viewQueue.current.add(photoId);
                scheduleFlush(); // batch update
            }
            });
        },
        {
            threshold: 0.25, // 25% of image must be visible
        }
        );
        return () => observerRef.current?.disconnect();
    }, []);

    /** Start observing a photo element */
    function registerPhotoRef(el) {
        setTimeout(() => {
        if (el) observerRef.current?.observe(el);
        }, 100);
    }

    async function handleClick(botId) {
        await fetch("/api/fc", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({id: botId, type: "mates"}),
            cache: "no-store"
        });
        ReactGA.event({
            category: "website",
            action: "ws_matelist_photo_click",
            //label: "your label", // optional
            //value: 99, // optional, must be a number
            //nonInteraction: true, // optional, true/false
            //transport: "xhr", // optional, beacon/xhr/image
        });
        router.push("/mate/" + botId);
    }
    
  return (
    <div >
        <div className="gradientBG">
            <Header title="Chatmate AI - Choose your mate to be friends with"/>
            <Section placeItems="" className=" px-0 pb-8">
                <div className="text-4xl font-bold mt-4 pb-6 text-white">Choose your mate</div>
                <BotFilters query={query} onQueryChange={(newquery) => {
                    //console.log("this is the query", newquery);
                    router.push(router.route + "?q=" + JSON.stringify(newquery) + "&p=" + 0);
                }}/>
            </Section>
        </div>
      
        <div className="bg-repeat">
            <div className="text-white text-xl py-8 m-auto" style={{maxWidth: "48em"}}>
                {!mounted || loading 
                    ? <div className="text-center text-black">Loading...</div> : 
                    <div className="grid grid-cols-2 md:flex flex-wrap justify-evenly">
                            {bots && (!bots.length
                                ? <div className="text-black my-40 text-2xl">No mates found like this, try be less specific.</div>
                                : bots.filter((bot) => {return !!bot.botId; }).map((bot) => {
                                    return <div key={bot.botId} ref={registerPhotoRef}
                                        data-photo-id={bot.botId}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleClick(bot.botId) }><BotListItem bot={bot}/></div>;
                                }))}

                            {/*(bots && !bots.length)
                                ? <div className="text-black my-40 text-2xl">No mates found like this, try be less specific.</div>
                                : undefined {bots && <BotCarousel bots={bots}/>}
                            }*/}
                


                    </div>
                }
            </div>
            {mounted && (botCount > pageSize) && <Pagination
                botCount={botCount}
                page={page}
                pageSize={pageSize}
                setPage={async (i) => {
                  setLoading(true);
                  window.scrollTo(0,0);
                  //setPage(i);
                  router.push(router.route + "?q=" + JSON.stringify(query) + "&p=" + i);
                  //setFiltersPageSortToLocalStorage(filterOptions, i, selectedSort, mode, textsearch);
                  //await getNewBots(i, query);
                }}
                getNewBots={getNewBots}
              />}
        </div>
       
      <Footer/>
    </div>

  );
}
